module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel-header', {
    attrs: {
      "title": _vm.title,
      "toggle-button-value": _vm.filterShow
    },
    on: {
      "toggleFilterPanel": _vm.toggleFilterPanel
    }
  }), _vm._v(" "), (_vm.filterShow) ? _c('toggle-filter-panel', {
    attrs: {
      "filters": _vm.filters
    },
    on: {
      "filterChange": _vm.filterChange,
      "defaultFilterChange": _vm.defaultFilterChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filterShow) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "inner clearfix"
  }, [_c('data-table', {
    attrs: {
      "dt-id": 'price-analysis-' + _vm.type,
      "my-ajax": _vm.dataTableAjax,
      "columns": _vm.columns,
      "column-defs": _vm.columnDefs,
      "refresh": _vm.DTRefresh,
      "on-click-element": ".row-details",
      "on-click-element-event": _vm.onClickEvent,
      "search": {
        handle: '.dt-df-box',
        placeholder: _vm.t('Name / Index / Ean')
      },
      "search-value": _vm.defaultFilter.search,
      "page-length": _vm.defaultFilter.pagination,
      "sort": false
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c4b4885!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PriceAnalysis/all.vue
// module id = 1232
// module chunks = 2